import { exemptionTypes,exemptionStatus,settledExemptionStatus,noActionExemptionStatus } from "./BACKEND-CONSTANTS";
export {
    exemptionTypes,
    exemptionStatus,
    settledExemptionStatus,
    noActionExemptionStatus
};

export const exemptionPageTitle = {
    [exemptionTypes.medFluVax]   : "Medical exemption request for flu vaccination",
    [exemptionTypes.medCovidVax] : "Medical exemption request for COVID-19 vaccination",
    [exemptionTypes.medCovidBooster] : "Medical exemption request for COVID-19 booster",
    [exemptionTypes.medN95Fit]   : "Medical exemption request for N95 fit test",
    [exemptionTypes.relFluVax]   : "Religious exemption request for flu vaccination",
    [exemptionTypes.relCovidVax] : "Religious exemption request for COVID-19 vaccination",
    [exemptionTypes.relCovidBooster] : "Religious exemption request for COVID-19 booster",
    [exemptionTypes.relN95Fit]   : "Religious exemption request for N95 fit test"
};

export const exemptionNameType = {
    [exemptionTypes.medFluVax]   : ["Medical","Flu vaccine"],
    [exemptionTypes.medCovidVax] : ["Medical","COVID-19 vaccine"],
    [exemptionTypes.medCovidBooster] : ["Medical","COVID-19 booster"],
    [exemptionTypes.medN95Fit]   : ["Medical","N95 fit test"],
    [exemptionTypes.relFluVax]   : ["Religious","Flu vaccine"],
    [exemptionTypes.relCovidVax] : ["Religious","COVID-19 vaccine"],
    [exemptionTypes.relCovidBooster] : ["Religious","COVID-19 booster"],
    [exemptionTypes.relN95Fit]   : ["Religious","N95 fit test"]
};